import { createContext } from 'react';

export interface DismissConfirmation {
  (): void;
  readonly accepted: boolean;
}

export interface ConfirmOptions {
  variant?: 'standard' | 'warning' | 'destructive' | 'info';
  confirmLabel?: string;
  cancelLabel?: string;
  /** Opt-in for legacy dialogs whose onOk promise kept the dialog open. */
  waitForCompletion?: boolean;
  /** Revalidate the live record/draft immediately before authorizing an action. */
  isCurrent?: () => boolean;
}

export interface ConfirmCtx {
  confirm(
    message: string,
    onOk: () => void,
    title?: string,
    onCancel?: () => void,
    options?: ConfirmOptions,
  ): DismissConfirmation;
}

const rejectedConfirmation = (() => undefined) as DismissConfirmation;
Object.defineProperty(rejectedConfirmation, 'accepted', { value: false });

export const ConfirmContext = createContext<ConfirmCtx>({
  confirm: () => rejectedConfirmation,
});
